import React from 'react'
import { Route, Switch } from 'react-router'
import ReportCustomerResults from './ReportCustomerResults'

const Components = props => (
    <Switch>
        <Route exact path={`${props.match.url}/:year?`} component={ReportCustomerResults} />
    </Switch>
)

export default Components
